
import React, { Component } from 'react';
import { FormGroup, Button, Input, FormText, Label } from 'reactstrap';
import Spinner from "react-spinners/ScaleLoader";
import ReactPinField from "react-pin-field"
import Switch from "react-switch";
import { BottomSheet } from 'react-spring-bottom-sheet'

const stringUtil = require('../../../../utils/string/stringUtil');
const validator = require('../../../../utils/validator/validator');
const stateManager = require('../../../../utils/state/stateManager');
const userApiProxy = require('../../../../utils/api/userApiProxy');
const viewUtil = require('../../../../utils/view/viewUtil');
const basketUtil = require('../../../../utils/basket/basketUtil');
const fatalErrorAction = require('../../../../utils/state/actions/error/fatalErrorAction');
const configurationManager = require('../../../../utils/config/configurationManager');
const storageUtil = require('../../../../utils/storage/storageUtil');
class User extends Component 
{
    constructor(props)
    {
        super(props);
        
        this.state = {};
        this.state.user = {
                            phoneNumber: "",
                            verificationCode: "",
                            isUserVerified: false,
                            remoteUser: null,
                           };

        this.state.waitMessage = "Loading Your Details";
        this.state.stage = 0;
        this.loadUserFromCache()
    }

    render()
    {
        var childComponent = null;

        var dismissAllowed = true;
        var headerComponent = null;
        var footerComponent = null;

        var footerButtonStyle = {
                                    color:`var(--button-continue-font-color)`, 
                                    background:`var(--button-continue-background-color)`,
                                    borderColor:`var(--button-continue-background-color)`,
                                    fontSize:`var(--button-continue-font-size)`,
                                    paddingLeft:'20px',
                                    paddingRight:'20px',
                                    marginRight:'5px',
                                    paddingLeft:'20px',
                                    paddingRight:'20px',
                                    paddingTop:'10px',
                                    paddingBottom:'10px',
                                    width:'80%',
                                    borderRadius:15,
                                    marginTop:'10px'
                                }

        if (this.state.stage == 0)
        {
            dismissAllowed = false;
            headerComponent = <div style={{fontWeight:'bold'}}>Please Wait</div>
            childComponent = this.renderWaitMessage();
            footerComponent = <div style={{textAlign:'center'}}>
                                    <Button disabled={true} style={footerButtonStyle}>Continue</Button> 
                               </div>
        }

        if (this.state.stage == 1)
        {
            dismissAllowed = true;
            headerComponent = <div style={{fontWeight:'bold'}}>Your Details</div>
            childComponent = this.renderUserDetails();
            footerComponent = <div style={{textAlign:'center'}}>
                                    {
                                        !this.state.user.isUserVerified ?
                                                <Button disabled={!this.isRemoteUserDetailsValid()}
                                                    style={{
                                                                color:`var(--button-change-font-color)`, 
                                                                background:`var(--button-change-background-color)`,
                                                                borderColor:`var(--button-change-background-color)`,
                                                                fontSize:`var(--button-change-font-size)`,
                                                                paddingLeft:'20px',
                                                                paddingRight:'20px',
                                                                marginRight:'5px',
                                                                paddingLeft:'20px',
                                                                paddingRight:'20px',
                                                                paddingTop:'10px',
                                                                paddingBottom:'10px',
                                                                width:'80%',
                                                                borderRadius:15,
                                                                marginTop:'10px'
                                                            }}
                                                    onClick={()=>
                                                            {
                                                                this.state.stage = 2;
                                                                this.setState({});
                                                                return;
                                                            }}>Change Details
                                                </Button> :
                                            null
                                    }
                                    <Button disabled={!this.isRemoteUserDetailsValid()}
                                        style={footerButtonStyle}
                                        onClick={()=>
                                                {
                                                    this.updateUserDetails();
                                                }}>Continue
                                    </Button>
                                </div>
        }

        if (this.state.stage == 2)
        {
            dismissAllowed = true;
            headerComponent = <div style={{fontWeight:'bold'}}>Your Phone Number</div>
            childComponent = this.renderPhoneNumberDetails();
            footerComponent = <div style={{textAlign:'center'}}>
                                    <Button disabled={!validator.isValidPhoneNumber(this.state.user.phoneNumber)}
                                        style={footerButtonStyle}
                                        onClick={()=>
                                                    {
                                                        this.onPhoneNumberEnter();
                                                    }}>Continue
                                    </Button>
                                </div>
        }

        

        if (this.state.stage == 3)
        {
            dismissAllowed = true;
            headerComponent = <div style={{fontWeight:'bold'}}>Verification Code</div>
            childComponent = this.renderPinDetails();
            footerComponent = <div style={{textAlign:'center'}}>
                                <Button disabled={true} style={footerButtonStyle}>Continue</Button> 
                              </div>
        }

        return <BottomSheet open={true} 
                        defaultSnap={({ maxHeight }) => Math.trunc(maxHeight * 0.80)}
                        snapPoints={({ minHeight, maxHeight }) => [Math.trunc(maxHeight * 0.80), Math.trunc(maxHeight * 0.80)]}

                        header={headerComponent}
                        footer={footerComponent}
                        onDismiss={()=>{
                                            if (!dismissAllowed)
                                                return;
                                            this.props.onDismiss();
                                        }
                                    }
                >
                    <div style={{marginBottom:'30px'}}>
                        {childComponent}
                    </div>
                </BottomSheet>
    }

    renderWaitMessage()
    {
        return (<div style={{position:'fixed', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}>
                    <div style={{textAlign:'center', whiteSpace:'nowrap'}}>
                        {this.state.waitMessage}
                    </div>
                    <div style={{textAlign:'center', whiteSpace:'nowrap'}}>
                        <Spinner color={`var(--spinner-color)`} size={40}/>
                    </div>
                </div>);
    }

    loadUserFromCache()
    {
        var appConfig = configurationManager.getAppConfig();
        storageUtil.readData(storageUtil.UserStoreName, appConfig.webOrderingExpiryForCachedUserPhoneNumber)
        .then(async (response)=>
                {
                    if (response == null)
                    {
                        
                        this.state.stage = 2;
                        this.setState({});
                        return;
                    }

                    this.state.user.remoteUser = await userApiProxy.loadUser(response.phoneNumber);
                    if (this.state.user.remoteUser == null || !this.isRemoteUserDetailsValid())
                    {
                        this.state.stage = 2;
                        this.setState({});
                        return;
                    }

                    this.state.user.isUserVerified = false;
                    this.state.stage = 1;
                    this.setState({});
                    return;

                }, (error) =>
                {
                    stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
                });
    }

    renderUserDetails()
    {
        var user = this.state.user;

        return <div style={{marginLeft:'10px', marginRight:'10px', marginTop:'20px'}}>
                    <FormGroup>
                        <Label>Your Phone Number</Label>
                        <Input
                            type="text" placeholder="Please enter your phone number" 
                            value={user.remoteUser.phoneNumber} readOnly={true} disabled={true}
                          />
                    </FormGroup>

                    <FormGroup>
                        <Label>Your Name</Label>
                        <Input
                            type="text" placeholder="Please enter your name" 
                            value={user.remoteUser.name}
                            disabled={!this.state.user.isUserVerified}
                            onChange={(event)=>
                                {
                                    user.remoteUser.name = event.target.value;
                                    this.setState({});
                                }}
                          />
                    </FormGroup>

                    {this.renderAddressDetails(user)}

                    <FormGroup>
                        <Label>Your Email</Label>
                        <Input
                            type="text" placeholder="Please enter your email address" 
                            value={user.remoteUser.emailAddress}
                            disabled={!this.state.user.isUserVerified}
                            onChange={(event)=>
                                {
                                    user.remoteUser.emailAddress = event.target.value;
                                    this.setState({});
                                }}
                          />
                    </FormGroup>
                    <FormGroup>
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{width:'99%'}}>
                                    You are ok if we contact you for our new offers
                                </td>
                                <td style={{whiteSpace:'nowrap'}}>
                                    <Switch className="react-switch" 
                                            checked={user.remoteUser.textNotificationEnabledForOffers} 
                                            disabled={!this.state.user.isUserVerified}
                                            onChange={(checked)=>
                                            {
                                                user.remoteUser.textNotificationEnabledForOffers = checked;
                                                this.setState({});
                                            }}/>
                                </td>
                            </tr>
                        </table>
                    </FormGroup>

                    <FormGroup>
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{width:'99%'}}>
                                    You are ok if we contact you for any of your order updates
                                </td>
                                <td style={{whiteSpace:'nowrap'}}>
                                    <Switch className="react-switch" 
                                            checked={user.remoteUser.textNotificationEnabledForOrderUpdates} 
                                            disabled={!this.state.user.isUserVerified}
                                            onChange={(checked)=>
                                                {
                                                    user.remoteUser.textNotificationEnabledForOrderUpdates = checked;
                                                    this.setState({});
                                                }}/>
                                </td>
                            </tr>
                        </table>
                    </FormGroup>
               </div>
    }

    renderAddressDetails(user)
    {
        if (!basketUtil.isAddressMandatoryForBasket())
            return null;

        return <FormGroup>
                    <Label>Your Address</Label>
                    <Input
                        type="text" placeholder="Please enter your address" 
                        value={user.remoteUser.address}
                        disabled={!this.state.user.isUserVerified}
                        onChange={(event)=>
                            {
                                user.remoteUser.address = event.target.value;
                                this.setState({});
                            }}
                    />
                </FormGroup>
    }

    renderPhoneNumberDetails()
    {
        var user = this.state.user;
        var width = Math.round(window.innerWidth * 0.90);
        return (<div style={{marginTop:'150px', marginLeft:'10px', marginRight:'10px', alignItems:'center', display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <div style={{marginTop:'5px'}}>
                        <Input inputMode='numeric' style={{width:`${width}px`}} type="email" name="email" id="exampleEmail" placeholder="Phone Number" 
                                onChange={(event) =>
                                {
                                    user.phoneNumber = event.target.value;
                                    this.setState({});
                                }}/>
                    </div>
                </div>);
    }

    onPhoneNumberEnter()
    {
        var user = this.state.user;
        this.state.stage = 0;
        this.state.waitMessage = "Sending verification code";
        this.setState({});

        userApiProxy.getPinCode(user.phoneNumber)
        .then(response =>
            {
                this.state.stage = 3;
                this.state.waitMessage = "";
                user.verificationCode = response;
                this.setState({});
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });
    }

    renderPinDetails()
    {
        var user = this.state.user;
        return (<div style={{marginTop:'100px', marginLeft:'10px', marginRight:'10px', alignItems:'center', display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <div style={{textAlign:'center'}}>
                        We have sent you a verification code to {user.phoneNumber}. Please enter it below
                    </div>
                    <ReactPinField inputMode='numeric' class="pin-field" length={4}
                                    onComplete={(code)=>
                                    {
                                        document.activeElement.blur();
                                        if (!stringUtil.areStringSame(code, user.verificationCode))
                                        {
                                            viewUtil.showErrorAlert("Pin does not match");
                                            return;
                                        }

                                        this.loadUserDetailsFromPhoneNumber();
                                    }}/>
                </div>);
    }

    loadUserDetailsFromPhoneNumber()
    {
        var user = this.state.user;
        this.state.stage = 0;
        this.state.waitMessage = "Loading Your Details";
        this.setState({});

        userApiProxy.loadUser(user.phoneNumber)
        .then(response =>
            {
                user.remoteUser = response;
                user.isUserVerified = true;
                if (user.remoteUser == null)
                {
                    user.remoteUser = {};
                    user.remoteUser.phoneNumber = user.phoneNumber;
                    user.remoteUser.textNotificationEnabledForOffers = false;
                    user.remoteUser.textNotificationEnabledForOrderUpdates = false;
                }
                this.state.stage = 1;
                this.state.waitMessage = "";
                this.setState({});
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });
    }

    isRemoteUserDetailsValid()
    {
        var remoteUser = this.state.user.remoteUser;

        if (stringUtil.isStringNullOrEmpty(remoteUser.phoneNumber))
            return false;

        if (stringUtil.isStringNullOrEmpty(remoteUser.name))
            return false;

        if (!stringUtil.isStringNullOrEmpty(remoteUser.emailAddress) &&
            !validator.isValidEmailAddress(remoteUser.emailAddress))
            return false;

        if (basketUtil.isAddressMandatoryForBasket() &&
            stringUtil.isStringNullOrEmpty(remoteUser.address))
            return false;
        return true;
    }

    updateUserDetails()
    {
        this.state.stage = 0;
        this.state.waitMessage = "Updating Your Details";
        this.setState({});

        var store = stateManager.getStore();
        var state = store.getState();
        var basket = state.basket;

        userApiProxy.updateUser(this.state.user.remoteUser)
        .then(async response =>
            {
                state.user = response;
                var cachedUser = {};
                cachedUser.phoneNumber = response.phoneNumber;
                storageUtil.updateData(storageUtil.UserStoreName, cachedUser);

                basket.dispatchInfo.deliveryAddress= "";
                basket.dispatchInfo.distance= -1;
                basket.dispatchInfo.deliveryCharges= -1;
                basket.doRequireEnrichment = true;
                basket.order.customerId = state.user.id;

                if (stringUtil.areStringSame(basket.order.dispatchType, "Delivery"))
                {
                    basket.dispatchInfo.deliveryAddress = state.user.address;
                }

                this.props.onComplete();

            }, error =>
            {
                store.dispatch(fatalErrorAction.createAction(error));
            });
    }
}

export default User;